import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-eagle-strategies",
    component: _cffe3db6,
    name: "about-eagle-strategies"
  }, {
    path: "/awards-accolades",
    component: _cffe3db6,
    name: "awards-accolades"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/education-credentials",
    component: _cffe3db6,
    name: "education-credentials"
  }, {
    path: "/personal-life",
    component: _cffe3db6,
    name: "personal-life"
  }, {
    path: "/about-us/meet-our-team",
    component: _cffe3db6,
    name: "meet-our-team"
  }, {
    path: "/about-us/our-holistic-process",
    component: _cffe3db6,
    name: "our-holistic-process"
  }, {
    path: "/about-us/strategic-affiliations",
    component: _cffe3db6,
    name: "strategic-affiliations"
  }, {
    path: "/businesses/executive-benefits",
    component: _cffe3db6,
    name: "executive-benefits"
  }, {
    path: "/businesses/funding-buy-sell-agreements",
    component: _cffe3db6,
    name: "funding-buy-sell-agreements"
  }, {
    path: "/businesses/funding-deferred-compensation",
    component: _cffe3db6,
    name: "funding-deferred-compensation"
  }, {
    path: "/businesses/key-person-insurance",
    component: _cffe3db6,
    name: "key-person-insurance"
  }, {
    path: "/businesses/succession-planning",
    component: _cffe3db6,
    name: "succession-planning"
  }, {
    path: "/client-education/calculators",
    component: _cffe3db6,
    name: "calculators"
  }, {
    path: "/client-education/financial-planning-pyramid",
    component: _cffe3db6,
    name: "financial-planning-pyramid"
  }, {
    path: "/get-in-touch/location-and-contact",
    component: _cffe3db6,
    name: "location-and-contact"
  }, {
    path: "/individuals/401k-and-ira-rollovers",
    component: _cffe3db6,
    name: "401k-and-ira-rollovers"
  }, {
    path: "/individuals/asset-protection",
    component: _cffe3db6,
    name: "asset-protection"
  }, {
    path: "/individuals/charitable-giving",
    component: _cffe3db6,
    name: "charitable-giving"
  }, {
    path: "/individuals/disability-and-extended-care-needs",
    component: _cffe3db6,
    name: "disability-and-extended-care-needs"
  }, {
    path: "/individuals/estate-planning",
    component: _cffe3db6,
    name: "estate-planning"
  }, {
    path: "/individuals/financial-planning-1",
    component: _cffe3db6,
    name: "financial-planning-1"
  }, {
    path: "/individuals/wealth-management",
    component: _cffe3db6,
    name: "wealth-management"
  }, {
    path: "/insurance/fixed-deferred-annuities",
    component: _cffe3db6,
    name: "fixed-deferred-annuities"
  }, {
    path: "/insurance/lifetime-income-annuities",
    component: _cffe3db6,
    name: "lifetime-income-annuities"
  }, {
    path: "/insurance/term-life",
    component: _cffe3db6,
    name: "term-life"
  }, {
    path: "/insurance/universal-life",
    component: _cffe3db6,
    name: "universal-life"
  }, {
    path: "/insurance/variable-deferred-annuities",
    component: _cffe3db6,
    name: "variable-deferred-annuities"
  }, {
    path: "/insurance/variable-universal-life",
    component: _cffe3db6,
    name: "variable-universal-life"
  }, {
    path: "/insurance/whole-life",
    component: _cffe3db6,
    name: "whole-life"
  }, {
    path: "/investment/financial-planning-2",
    component: _cffe3db6,
    name: "financial-planning-2"
  }, {
    path: "/investment/fund-advisory-program",
    component: _cffe3db6,
    name: "fund-advisory-program"
  }, {
    path: "/investment/investment-advisory",
    component: _cffe3db6,
    name: "investment-advisory"
  }, {
    path: "/investment/rep-directed-program",
    component: _cffe3db6,
    name: "rep-directed-program"
  }, {
    path: "/investment/separately-managed-accounts",
    component: _cffe3db6,
    name: "separately-managed-accounts"
  }, {
    path: "/our-expertise/business-solutions",
    component: _cffe3db6,
    name: "business-solutions"
  }, {
    path: "/our-expertise/insurance-and-annuities",
    component: _cffe3db6,
    name: "insurance-and-annuities"
  }, {
    path: "/our-expertise/investment-solutions",
    component: _cffe3db6,
    name: "investment-solutions"
  }, {
    path: "/our-expertise/personal-solutions",
    component: _cffe3db6,
    name: "personal-solutions"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "home"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
